import "./SiteFooter.css";
import Propulator from "higher-order/Propulator";
import React from "react";
import classNames from "classnames";
import isNull from "lodash/isNull";
import RequestDemoButton from "shared/components/marketing/RequestDemoButton";
import CpraScript from "shared/components/CpraScript";
import TrackedLink from "gradifui/components/TrackedLink";
import { SharedContentItem } from "../cms/SharedContent";
import { URLS } from "util/constants";
import moment from "moment/moment";

const SharedItem = SharedContentItem("siteFooter");

class SiteFooter extends React.PureComponent {

    renderPrivacyLoggedIn() {
        return (
            <div className="privacy-logged-in">
                <div className="privacy-section">
                    <a href={URLS.MARKETING.PRIVACY_POLICY} target="_blank">Privacy Policy</a>
                    <CpraScript />
                </div>
                <div className="terms-section">
                    <a href={URLS.MARKETING.WEBSITE_TERMS} className="website-terms" target="_blank">Platform Terms of Use</a>
                    <a href={URLS.MARKETING.MEMBER_TERMS} target="_blank">Member Terms &amp; Conditions</a>
                </div>
            </div>
        );
    }

    renderPrivacyLoggedOut() {
        return (
            <ul>
                <li><a href={URLS.MARKETING.PRIVACY_POLICY} target="_blank">Privacy Policy</a></li>
                <li>
                    <CpraScript />
                </li>
                <li><a href={URLS.MARKETING.WEBSITE_TERMS} target="_blank">Platform Terms of Use</a></li>
            </ul>
        );
    }

    render() {
        const isLoggedIn = this.props.session?.isLoggedIn;
        const siteFooterModel = this.props.session?.siteFooterModel ?? {};
        const isMemberPortal = siteFooterModel?.isMemberPortal;
        const memberSupportEmail = siteFooterModel?.memberSupportEmail ?? "";
        const memberSupportNumber = siteFooterModel?.memberSupportNumber ?? "";
        const showCpraLink = this.props.session?.featureToggles?.cpraFooterLink;
        const requestInfoUrl = this.props.session?.requestInfoUrl;

        const today = this.props.session?.getCurrentUtcNow() ?? moment();
        const copyrightStringFormatArgs = { year: today.year() };
        
        return (
            <footer className="site-footer">
                <div className="site-footer-content content-wrapper">
                    <div className="social-content">
                        <a className="logo" href={URLS.HOME}>
                            <div className="footer-logo" role="img" aria-label="Gradifi" />
                        </a>
                        <a href={this.props.externalUrls?.linkedIn ?? ""} target="_blank">
                            <div className="linkedin-logo" role="img" alt="Follow us on LinkedIn" />
                        </a>
                    </div>
                    <div className="link-content">
                        <div className={classNames("static-columns", { "employer-portal": !isMemberPortal && isLoggedIn })} >
                            <div className="link-column products-column">
                                <ul>
                                    <li><h4>Products</h4></li>
                                    <li><TrackedLink eventLabel="footer-refi" href={URLS.MARKETING.REFI} target="_blank">FinancialCore</TrackedLink></li>
                                    <li><TrackedLink eventLabel="footer-student-loan-paydown" href={URLS.MARKETING.PAYDOWN} target="_blank">Student Loan PayDown</TrackedLink></li>
                                    <li><TrackedLink eventLabel="footer-saveup" href={URLS.MARKETING.SAVEUP} target="_blank">College SaveUp</TrackedLink></li>
                                </ul>
                            </div>
                            <div className="link-column about-column">
                                <ul>
                                    <li><h4>About</h4></li>
                                    <li><a target="_blank" href={URLS.MARKETING.CAREERS}>Careers</a></li>
                                    <li><a href={URLS.MARKETING.CONTACT} target="_blank">Contact</a></li>
                                </ul>
                            </div>
                        </div>
                        {isMemberPortal &&
                            <div className="link-column member-support-column">
                                <ul>
                                    <li>
                                        <h4>Member Support</h4>
                                    </li>
                                    {!isNull(memberSupportNumber) &&
                                        <li className="member-support-phone">
                                            Phone: <a href={"tel:+" + memberSupportNumber}>(844) GRADIFI (472-3434)</a>
                                        </li>
                                    }
                                    {!isNull(memberSupportEmail) &&
                                        <li className="member-support-email">
                                            Email: <a href="mailto:membersupport@gradifi.com?subject=Gradifi member support question">{memberSupportEmail}</a>
                                        </li>
                                    }
                                    <li>
                                        Hours of Support: Monday - Friday 8:00 AM to 8:00 PM EST
                                    </li>
                                </ul>
                            </div>
                        }
                        {!isLoggedIn &&
                            <div className="link-column demo-column demo-login-content">
                                <ul>
                                    <li>
                                        <RequestDemoButton url={requestInfoUrl} />
                                    </li>
                                    <li>
                                        <a href={this.props.session.loginPath}>Login/Register</a>
                                    </li>
                                </ul>
                            </div>
                        }
                    </div>
                </div>
                <div className="privacy-terms-row content-wrapper">
                    {!showCpraLink &&
                        <ul>
                            <li><a href={URLS.MARKETING.PRIVACY_POLICY} target="_blank">Privacy</a></li>
                            <li><a href={URLS.MARKETING.WEBSITE_TERMS} target="_blank">Platform Terms of Use</a></li>
                            {isLoggedIn &&
                                <li><a href={URLS.MARKETING.MEMBER_TERMS} target="_blank">Member Terms &amp; Conditions</a></li>
                            }
                        </ul>
                    }
                    {showCpraLink && !isLoggedIn &&
                        this.renderPrivacyLoggedOut()
                    }
                    {showCpraLink && isLoggedIn &&
                        this.renderPrivacyLoggedIn()
                    }
                </div>
                <div className="disclosure-row content-wrapper">
                    <div className="disclosure-items">
                        <SharedItem tag="p" contentKey="disclaimer1_v3" />
                        <br />
                        <SharedItem tag="p" contentKey="disclaimer2_v3" />
                    </div>
                    <div className="disclosure-items">
                        <SharedItem tag="p" contentKey="disclaimer5_v3" />
                        <br />
                        <SharedItem tag="p" contentKey="disclaimer6_v3" />
                        <br />
                        <SharedItem tag="p" contentKey="copyright_v4" stringFormatArgs={copyrightStringFormatArgs} />
                    </div>
                </div>
            </footer>
        );
    }
}

export default Propulator(SiteFooter, {
    sessionStore: [
        "session",
        "externalUrls"
    ]
});
